import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import * as FileSaver from 'file-saver';
import { UtilityService } from '../../services/utility/utility.service';
import MobileDetect from 'mobile-detect';

import printJS from 'print-js';
//declare var printJS: any;

@Component({
  selector: 'upsc-ship-label',
  templateUrl: './ship-label.component.html',
  styleUrls: ['./ship-label.component.scss'],
})
export class ShipLabelComponent implements OnInit {
  @Input() labelImage: string;
  @Input() labelPdf: string;
  @Input() podPdf: string;
  @Input() shouldShowLabel = false;
  @Input() shouldPrintLabel = false;

  @ViewChild('printFile', { static: true }) public printFile: ElementRef;
  @ViewChild('printButton', { static: true }) public printButton: ElementRef;

  constructor(private utilityService: UtilityService,
    private sanitizer: DomSanitizer) {
  }

  public ngOnInit() {
    this.renderLabel();

    const md = new MobileDetect(window.navigator.userAgent);
    if (this.shouldPrintLabel && !md.mobile()) {
      this.printLabel();
    }
  }

  public getSafeImageUrl() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.labelImage);
  }

  public getSafePdfUrl() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.labelPdf);
  }

  private getBlob(base64String: string) {
    if (!base64String) {
      return;
    }

    const contentType = base64String.split(';')[0].split(':')[1];
    const byteCharacters = atob(base64String.split(',')[1]);
    const byteNumbers = [];

    for (let i = 0; i < byteCharacters.length; i = i + 1) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: contentType });
  }

  private getBlobObjectURL(blob) {
    return window.URL.createObjectURL(blob);
  }

  public getSanitizedBlob(base64String: string) {
    const blobObjectUrl = this.getBlobObjectURL(this.getBlob(base64String));
    return this.sanitizer.bypassSecurityTrustUrl(blobObjectUrl);
  }

  public downloadLabel(event?) {
    if (event) {
      event.preventDefault();
    }

    const blob = this.getBlob(this.labelPdf);
    // const blobObjectUrl = this.getBlobObjectURL(blob);
    // const a = document.createElement('a');
    // document.body.appendChild(a);
    // a.style.display = 'none';
    // a.href = blobObjectUrl;
    // a.download = 'shipment-label.pdf';
    // a.click();
    // window.URL.revokeObjectURL(blobObjectUrl);
    // a.remove();

    FileSaver.saveAs(blob, 'shipment-label.pdf');
  }

  public downloadPOD(event?) {
    if (event) {
      event.preventDefault();
    }

    const blob = this.getBlob(this.podPdf);

    FileSaver.saveAs(blob, 'proof-of-delivery.pdf');
  }

  public printLabel() {
    const iframe = this.printFile.nativeElement;
    this.utilityService.delay(
      () => {
        try {
          const blob = this.getBlob(this.labelPdf);
          const blobObjectUrl = this.getBlobObjectURL(blob);

          // IE 11 blocks display of blob, we need to use the following
          if (window.navigator.msSaveOrOpenBlob) {
            if (window.navigator.userAgent.match(/edge/i)) {
              const link = document.createElement('a');
              link.href = this.getBlobObjectURL(blob);
              link.download = "shipment-label.pdf";
              link.click();              
              return
            }
            window.navigator.msSaveOrOpenBlob(blob);
            return;
          }          

          if (window.navigator.userAgent.match(/chrome/i)) {
            iframe.contentWindow.print();
            return;
          }
          window.open(blobObjectUrl);
          //printJS(blobObjectUrl);

          return;
        } catch (e) {
          console.warn('Printing PDF is not supported');
          console.warn(e);
        }
      });
  }

  private renderLabel() {
    const blob = this.getBlob(this.labelPdf);
    const blobObjectUrl = this.getBlobObjectURL(blob);

    const iframe = this.printFile.nativeElement;

    const md = new MobileDetect(window.navigator.userAgent);
    const isChromeOnAndroid = md.os() === 'AndroidOS' && md.userAgent() === 'Chrome';

    // [MV3-1618] Firefox automatically downloads a file if the file URL is set to an iframe's source.
    // [MV3-1854] prevent Chrome on Android from auto downloading a label.
    if (!window.navigator.userAgent.match(/firefox/i) && !isChromeOnAndroid) {
      iframe.src = blobObjectUrl;
    }

    // const pdfObject = document.getElementById('pdfObject');
    // pdfObject.setAttribute('data', this.labelPdf);
  }
}
